import {
  buildServices
} from './utils/build_services'
import buildParamList from './utils/build_params'
import omitBy from 'lodash.omitby'
import isEmpty from 'lodash.isempty'

import {
  adaptFilesToStore
} from './adapters/fileAdapter'
import {
  buildHeaders
} from './utils/build_headers'

import { FILES } from '@/services/axios.config'

const services = [
  {
    name: 'listFiles',
    method: 'get',
    url: (params) => `/files${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptFilesToStore
  },
  {
    name: 'getFile',
    method: 'get',
    url: (params) => `/files/${params.fileId}`
  },
  {
    name: 'createFile',
    method: 'post',
    url: () => `/files`,
    data: (params) => {
      return {
        name: params.file.name,
        url: params.file.url,
        type: params.file.type
      }
    }
  },
  {
    name: 'editFile',
    method: 'put',
    url: (params) => `/files/${params.file.id}`,
    data: (params) => {
      return {
        name: params.file.name,
        url: params.file.url,
        type: params.file.type
      }
    }
  },
  {
    name: 'partialEditFile',
    method: 'patch',
    url: (params) => `/files/${params.file.id}`,
    data: (params) => {
      return params.payload
    }
  },
  {
    name: 'deleteFile',
    method: 'delete',
    url: (params) => `/files/${params.file.id}`
  },
  {
    name: 'uploadFile',
    method: 'post',
    url: () => `/files/upload`,
    headersFactory: buildHeaders({
      'Content-Type': undefined
    }),
    data: (params) => {
      return params.file
    }
  },
  {
    name: 'reUploadFile',
    method: 'patch',
    url: (params) => `/files/${params.fileId}/reupload`,
    headersFactory: buildHeaders({
      'Content-Type': undefined
    }),
    data: (params) => {
      return params.file
    }
  },
]

export const {
  listFiles,
  getFile,
  createFile,
  editFile,
  deleteFile,
  uploadFile,
  partialEditFile,
  reUploadFile,
} = buildServices(FILES, services)